// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607272104/js/" + chunkId + "." + {"44":"3b829209","225":"c67b9a47","481":"564926d3","486":"231dceb6","770":"c7474091"}[chunkId] + ".0.25048252504286583.chunk.js";
};